
import { Component, Vue, Provide } from 'vue-property-decorator'
import Usuario from 'higia-lib-components/src/lib-components/domains/user.dto'

@Component({ name: 'GlobalProviderService' })
export default class ServiceProvider extends Vue {
    @Provide('usuario')
    usuario: Usuario = new Usuario()
}
